module.exports = __webpack_public_path__ + "static/sprite-creativemarketing-685039f83829397235fc508249ece761.png";